export default __webpack_public_path__ + "static/media/Home-background.7b275d01.png";